import useApi from "../useApi";

const BASE = "/permissions";

/**
 * All permissions (GET /api/permissions).
 * Response shape: { success, data: [permissions], meta: { total, modules, ... } }
 */
export const usePermissionsList = () => {
  const api = useApi(BASE, {
    method: "GET",
    immediate: true,
    errorMessage: "Failed to fetch permissions",
  });

  const refetch = async () => {
    try {
      await api.execute();
      return { success: true };
    } catch (err) {
      return {
        success: false,
        message: err.response?.data?.message || "Failed to fetch permissions",
      };
    }
  };

  return {
    data: api.data?.data ?? [],
    meta: api.data?.meta ?? null,
    loading: api.loading,
    error: api.error,
    refetch,
  };
};

export const useCreatePermission = () =>
  useApi(BASE, { method: "POST", errorMessage: "Failed to create permission" });

export const useUpdatePermission = () => {
  const api = useApi((id) => `${BASE}/${id}`, {
    method: "PUT",
    errorMessage: "Failed to update permission",
  });
  const execute = async (id, payload) => {
    if (!id) throw new Error("Permission id is required");
    return api.execute(id, payload);
  };
  return { execute, loading: api.loading, error: api.error };
};

export const useDeletePermission = () => {
  const api = useApi((id) => `${BASE}/${id}`, {
    method: "DELETE",
    errorMessage: "Failed to delete permission",
  });
  const execute = async (id) => {
    if (!id) throw new Error("Permission id is required");
    return api.execute(id);
  };
  return { execute, loading: api.loading, error: api.error };
};
